import { z } from 'zod';
import { LoanRequestsTableDefinitionZod } from '../../tables/LoanRequests';

export const LeadForQueueSchema = LoanRequestsTableDefinitionZod.pick({
    correlationWebsite: true,
    customId: true,
    id: true,
    leadTS: true,
    tracking: true,
    type: true,
});

export type LeadForAttributionQueue = z.infer<typeof LeadForQueueSchema>;
